import PreloadView from "../../../vendor_core/core/src/views/PreloadView";

// The bar is drawn at (0.25 + progress) of its width, so it is full at 0.75
const FULL_BAR_PROGRESS = 0.75;

/**
 * The loading bar covers everything that has to be done before the start screen shows: the share of it that
 * the asset loading (which reports to handleProgress) takes is ASSETS_SHARE, the rest is filled with showProgress
 */
export default class BURPreloadView extends PreloadView {
    public static readonly ASSETS_SHARE = 0.7;

    public handleProgress(progress: number) {
        this.showProgress(
            Math.min(progress, 1) * BURPreloadView.ASSETS_SHARE
        );
    }

    /**
     * @param fraction how much of the whole loading is done, from 0 to 1
     */
    public showProgress(fraction: number) {
        super.handleProgress(Math.min(fraction, 1) * FULL_BAR_PROGRESS);
    }
}
